import {useMutation} from '@apollo/react-hooks';

import type {
    PreviewPage as PreviewPageMutation,
    PreviewPageVariables as PreviewPageMutationVariables,
} from 'nutshell-graphql-types';

import PREVIEW_PAGE from '../mutations/preview-page.graphql';

export function usePreviewPage(): {
    previewPage: (pageId: string) => Promise<any>;
} {
    const [pagePreviewPage] = useMutation<PreviewPageMutation, PreviewPageMutationVariables>(
        PREVIEW_PAGE
    );

    return {
        previewPage: (pageId: string) =>
            pagePreviewPage({
                variables: {input: {pageId}},
            }),
    };
}
